import { render, staticRenderFns } from "./AddVehicule.vue?vue&type=template&id=1fa9acf1&"
import script from "./AddVehicule.vue?vue&type=script&lang=js&"
export * from "./AddVehicule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports